import { ApplicationRoutes } from '../../../app-routes-names'

export const SchedulerRoutes = {
  list: 'list',
  location: 'location',
  locationWithId: 'location/:locationId/:weekNumber',
  attendance: 'attendance'
}

const { scheduler } = ApplicationRoutes

export const SchedulerPaths = {
  list: `/${scheduler}/${SchedulerRoutes.list}`,
  location: `/${scheduler}/${SchedulerRoutes.location}`,
  locationWithId: (locationId: string, weekNumber: string) =>
    `/${scheduler}/${SchedulerRoutes.locationWithId.replace(':locationId', locationId).replace(':weekNumber', weekNumber)}`,
  attendance: `/${scheduler}/${SchedulerRoutes.attendance}`
}
